import $ from 'jquery';
import { trackPsykheAddToCart } from "../../modules/psykhe";

export default function addToBag(productcode, size, returnElement, showConfirmation, addlData) {
    if(size==undefined || size==''){
        return;
    }

    if(window.hasReachedBagLimit(productcode, size, 1)){
        return;
    }

    if (typeof window.gaAddToCartActionWithAjax === 'function'){
        window.gaAddToCartActionWithAjax('add',productcode, size,1);
    }

    insertCordialAddToBagFromDisplayProduct(productcode, size);

    if(typeof insertFacebookAddToCart === 'function'){
        window.insertFacebookAddToCart(productcode, null);
    }
    if(typeof insertTiktokAddToCart === "function"){
        insertTiktokAddToCart(productcode);
    }
    if(typeof iPinYouAddtoCart === 'function'){
        window.iPinYouAddtoCart(productcode);
    }

    if (typeof insertCriteoAddToCart === 'function') {
        insertCriteoAddToCart(productcode);
    }
    if (typeof insertKakaoAddToCart === 'function') {
        insertKakaoAddToCart(productcode);
    }
    if (typeof insertRTBHouseAddToCart === 'function') {
        insertRTBHouseAddToCart(productcode);
    }
    if (typeof insertTaboolaAddToCart === 'function') {
        insertTaboolaAddToCart("add", productcode);
    }

    if (typeof brazeAddToCart === 'function') {
        if (window.rcProps && window.rcProps.pdp) {
            brazeAddToCart('add',
                productcode,
                window.rcProps.pdp.productName,
                size,
                window.rcProps.pdp.imageUrl,
                window.rcProps.pdp.pdpUrl,
                window.rcProps.pdp.retailPrice,
                window.rcProps.pdp.currency,
                window.rcProps.pdp.department,
                window.rcProps.pdp.color,
                window.rcProps.pdp.brandName,
                window.rcProps.pdp.categoryName,
                window.rcProps.pdp.cat1
            );
        } else if (addlData) {
            brazeAddToCart('add',
                productcode,
                addlData.name,
                size,
                addlData.imageurl,
                addlData.pdpurl,
                addlData.price,
                addlData.currency,
                addlData.department,
                addlData.color,
                addlData.brand,
                addlData.category,
                addlData.cat1
            );
        }
    }

    var pdpData = window.rcProps.pdp || {};
    var isMens = pdpData.d == 'Mens';
    var dept = window.rcProps && window.rcProps.department ? window.rcProps.department : "";

    var data = $.param({
        colorSelect : productcode,
        sizeSelect : size,
        isMens : isMens,
        count : 1,
        d: dept,
        sectionURL : pdpData.sectionURL
    });



    $.post("/r/ajax/AddItemToBag.jsp", data, function(res) {
        const result = parseRtn(res);
        if (result && result.reCAPTCHA) {
            $.modal({
                url: "/fw/dialog/VerifyHuman.jsp?mobile=true",
                type: "full",
                open: null,
                cache: false,
                overlayClose: true,
                closeButton: false,
                triggerOpen: true,
                onClose : function(){
                    if(window.rcProps && typeof window.rcProps.ReCAPTCHARestore =='function'){
                        window.rcProps.ReCAPTCHARestore();
                        window.rcProps.ReCAPTCHARestore = "";
                    }                    
                }
            });

            return;
        }

        if(typeof window.insertPageTrackForMobile === 'function') {
            window.insertPageTrackForMobile(true);
        }

        if (showConfirmation === undefined || showConfirmation === true) {
            if ($('#product-added-confirmation-container').length) {
                $.get("/fw/content/product/productAddedConfirmationModal", {
                    code: productcode,
                    size: size
                }, function (markup) {
                    $("#product-added-confirmation-container").html(markup);
                    $.modal({
                        open: "product-added-confirmation",
                        triggerOpen: true,
                        triggerElement: returnElement ? $(returnElement.target) : null,
                        onOpen: function () {
                            const dataType = $("#product-added-confirmation").data('type');
                            if (dataType === 'toast') {
                                const jsCarouselCtlAtb = $(".js-carousel-ctl-atb");
                                jsCarouselCtlAtb.not('.slick-initialized').slick({
                                    arrows: false,
                                    lazyLoad: 'ondemand',
                                    slidesToShow: 3,
                                    slidesToScroll: 2,
                                    accessibility: true
                                });
                            }
                        },
                    });
                });
            } else if ($('#top-modal').length > 0) {
                //wishlist.jsp page
                $.modal({
                    open: 'top-modal',
                    triggerOpen: true
                });
            } else if (window.rcProps.shoppingBag) {
                $(window).trigger('shoppingbag.wishlist.added.to.bag');
            }
        }


        $.ajax({
            type: "POST",
            url: "/fw/mobile/AjaxUserShoppingBag.jsp",

            success: function(response) {
                var responseObj = eval('(' + response + ')');
                $("#shopping_bag_count").html(responseObj);
                if (typeof insertGoogleRemarketingAddToCart === 'function') {
                    insertGoogleRemarketingAddToCart();
                }
                if (typeof addToCartYahoo === 'function'){
                    addToCartYahoo(productcode);
                }
            }
        });

        trackPsykheAddToCart(productcode, result);
    });
}

function insertCordialAddToBagFromDisplayProduct(code, size) {
    var pdpData = window.rcProps.pdp || {};

    var cartItems = new Array();
    var cartItem = {};
    cartItem.productCode = code;
    cartItem.productName = pdpData.productName;
    cartItem.productCategory = pdpData.categoryName;
    cartItem.brandName = pdpData.brandName;
    cartItem.price = pdpData.price;
    cartItem.images = [pdpData.imageUrl];
    cartItem.size = size;
    cartItem.description = pdpData.description;
    cartItem.url = pdpData.url;
    cartItem.department = pdpData.department;
    cartItem.cat1 = pdpData.cat1;
    cartItems.push(cartItem);
    if(typeof window.insertCordialAddToCart === 'function'){
        window.insertCordialAddToCart(cartItems);
    }
}



// WEBPACK FOOTER //
// ./src/scripts/entry-points/pdp/add-to-bag.js